import { API, Auth } from "aws-amplify"
import { useQuery, useMutation } from "@tanstack/react-query"

const fetchBusinessUnitTags = async organization_id => {
  try {
    const params = [
      `organization_id=${organization_id}`,
      "category=T",
      "object_type=business_unit",
    ].join("&")
    const res = await API.get("CORE", `/tags?${params}`)

    return res
  } catch (error) {
    console.error("❌ Error in fetchBusinessUnitTags:", error)
    throw error
  }
}

export const useBusinessUnitTags = (organization_id, enabled = true) => {
  return useQuery({
    queryKey: ["businessUnitTags", organization_id],
    queryFn: () => fetchBusinessUnitTags(organization_id),
    enabled,
  })
}

const fetchCreateBusinessUnitTag = async ({
  organizationId,
  tagName,
  tagColor,
  category = "T",
  objectType = "business_unit",
}) => {
  try {
    const token = (await Auth.currentSession()).getIdToken().getJwtToken()
    const payload = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
      },
      body: {
        name: tagName,
        color: tagColor,
        category: category,
        object_type: objectType,
        organization_id: organizationId,
      },
    }
    const response = await API.post("CORE", `/tags/`, payload)

    return response
  } catch (error) {
    console.error("❌ Error in fetchCreateBusinessUnitTag:", error)
    throw error
  }
}

export const useCreateBusinessUnitTag = () => {
  return useMutation({
    mutationFn: fetchCreateBusinessUnitTag,
  })
}

const fetchDeleteBusinessUnitTag = async ({ organizationId, tagSKs }) => {
  try {
    const token = (await Auth.currentSession()).getIdToken().getJwtToken()
    const payload = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
      },
      body: {
        organization_id: organizationId,
        sks: tagSKs,
      },
    }
    const response = await API.del("CORE", `/tags/`, payload)

    return response
  } catch (error) {
    console.error("❌ Error in fetchDeleteBusinessUnitTag:", error)
    throw error
  }
}

export const useDeleteBusinessUnitTag = () => {
  return useMutation({
    mutationFn: fetchDeleteBusinessUnitTag,
  })
}
